module.exports = __webpack_public_path__ + "img/fj.41e534b.svg";